var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          d:
            "M17.601,14.601 L6.401,14.601 C5.958,14.601 5.601,14.243 5.601,13.801 L5.601,9.376 L18.402,9.376 L18.402,13.801 C18.402,14.243 18.043,14.601 17.601,14.601 M6.401,6.601 L17.601,6.601 C18.043,6.601 18.402,6.959 18.402,7.4 L18.402,7.898 L5.601,7.898 L5.601,7.4 C5.601,6.959 5.958,6.601 6.401,6.601 M6.401,5 C5.075,5 4,6.075 4,7.4 L4,13.801 C4,15.127 5.075,16.202 6.401,16.202 L11.201,16.202 L11.201,18.4 L8.001,18.4 C7.559,18.4 7.201,18.758 7.201,19.2 C7.201,19.642 7.559,20 8.001,20 L16.001,20 C16.443,20 16.802,19.642 16.802,19.2 C16.802,18.758 16.443,18.4 16.001,18.4 L12.8,18.4 L12.8,16.202 L17.601,16.202 C18.927,16.202 20.001,15.127 20.001,13.801 L20.001,7.4 C20.001,6.075 18.927,5 17.601,5 L6.401,5 Z",
          id: "display_grid"
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "g",
      {
        attrs: {
          id: "Page-1",
          stroke: "none",
          "stroke-width": "1",
          fill: "none",
          "fill-rule": "evenodd"
        }
      },
      [
        _c(
          "g",
          {
            attrs: {
              id: "Desktop-HD",
              transform: "translate(-210.000000, -270.000000)"
            }
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Group",
                  transform: "translate(210.500000, 270.000000)"
                }
              },
              [
                _c("rect", {
                  staticStyle: { "mix-blend-mode": "color-burn" },
                  attrs: {
                    id: "Rectangle",
                    "fill-opacity": "0.01",
                    fill: "#E3E3E3",
                    x: "0",
                    y: "0",
                    width: "24",
                    height: "24"
                  }
                }),
                _vm._v(" "),
                _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                  _c("use", { attrs: { "xlink:href": "#display_grid" } })
                ]),
                _vm._v(" "),
                _c("use", {
                  attrs: {
                    id: "Mask",
                    fill: _vm.currentColor,
                    opacity: _vm.opacity,
                    "xlink:href": "#display_grid"
                  }
                })
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }